import React from "react";
import MultipleSelect from "../MultipleSelect/MultipleSelect";
import RadioInput from "../RadioInput/RadioInput";
import TextInput from "../TextInput/TextInput";
import UploadFile from "../UploadFile/UploadFile";

const valueContainer = {
  display: "flex",
  gap: "5px",
};

const TextInfo = ({
  title,
  value,
  type = "text",
  isTextArea = false,
  isInputNumber = false,
  radioData,
  id,
  handleChange,
  error = "",
  placeholder,
  isSearchable = false,
  selectOptions = [],
  isForm = false,
  helperText = "",
  handleImageChange,
  customRequest,
  fileList,
  isStyleBlock = false,
  disabled = false,
}) => {
  return (
    <>
      {isTextArea && isStyleBlock ? (
        <div>
          <div className="modal-title" style={{ marginBottom: "10px" }}>
            {title} :
          </div>
          <TextInput
            id={id}
            isInputNumber={isInputNumber}
            isTextArea={isTextArea}
            handleChange={handleChange}
            value={value}
            width="100%"
            errorText={error}
            placeholder={placeholder}
            isForm={isForm}
          />
        </div>
      ) : (
        <>
          <div className="modal-title">{title}</div>
          {type === "text" ? (
            <div style={valueContainer}>
              : <div>{value}</div>
            </div>
          ) : type === "select" ? (
            <div className="d-flex modal-input align-items-flex-start">
              <span>: </span>
              <MultipleSelect
                id={id}
                label={title}
                value={value}
                isSearchable={isSearchable}
                onSelectChange={handleChange}
                placeholder={placeholder}
                options={selectOptions}
                isForm={isForm}
                width="100%"
                errorText={error}
              />
            </div>
          ) : type === "upload" ? (
            <div className="d-flex modal-input align-items-flex-start ">
              <span>{title !== "" ? ':' : ' '}</span>
              <UploadFile
                id={id}
                buttonText={"Tambah File"}
                isForm={isForm}
                width="100%"
                helperText={helperText}
                handleImageChange={handleImageChange}
                customRequest={customRequest}
                fileList={fileList}
                errorText={error}
                disabled={disabled}
              />
            </div>
          ) : type === "radio" ? (
            <div className="d-flex modal-input align-items-flex-start">
              <span>: </span>
              <div className="d-flex flex-column">
                <RadioInput
                  value={value}
                  id={id}
                  radioData={radioData}
                  handleChange={handleChange}
                  errorText={error}
                  width="100%"
                  isForm
                />
              </div>
            </div>
          ) : (
            <div className="d-flex modal-input align-items-flex-start">
              <span>: </span>
              <TextInput
                id={id}
                isInputNumber={isInputNumber}
                isTextArea={isTextArea}
                handleChange={handleChange}
                value={value}
                width="100%"
                errorText={error}
                placeholder={placeholder}
                isForm={isForm}
              />
            </div>
          )}
        </>
      )}
    </>
  );
};

export default TextInfo;
